  <h2 mat-dialog-title>   
   <span class="groupIcon">
      <mat-icon>speaker_notes</mat-icon>
    </span> 
    <p *ngIf="noteID==0">Add Notes </p>   
    <p *ngIf="noteID>0">Update Notes </p>     
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
    
  </h2>

<mat-dialog-content>
  <form [formGroup]="myCustomInfoForm" class="fix-mat-form-field">    
  
    <div class="divideCol">
      <mat-form-field>
        <mat-label>Title</mat-label>
        <input matInput formControlName="title" placeholder="Enter title" />       
      </mat-form-field>    
    </div>

    <mat-form-field>
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="description" placeholder="Add description"
        rows="22">
      </textarea>
    </mat-form-field>

  

  </form>
  </mat-dialog-content>
  
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button *ngIf="noteID==0" mat-flat-button class="calltoaction" [disabled]="myCustomInfoForm.invalid || !myCustomInfoForm.dirty" type="submit"
      (click)="AddFileNote(myCustomInfoForm.value)" color="primary">
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
      </mat-spinner></mat-icon>
      Save
    </button>  

    <button *ngIf="noteID>0" mat-flat-button class="calltoaction" 
      (click)="deleteFileNote()" color="warn">     
      Delete
    </button>  

    <button *ngIf="noteID>0" mat-flat-button class="calltoaction" [disabled]="myCustomInfoForm.invalid || !myCustomInfoForm.dirty" type="submit"
      (click)="UpdateFileNote(myCustomInfoForm.value)" color="primary">    
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
      </mat-spinner></mat-icon> 
      Update
    </button>   
  </mat-dialog-actions>



  

  




